<div class="no-results-message">
    <svg-image name="loving-it" class="icon"></svg-image>
    <div class="main" trans>Nothing is starred.</div>
    <div class="secondary" trans>Add stars to files and folders that you want to easily find later.</div>
</div>
